import { useAuth } from '../../context/Auth';
import { WorkspacesProvider } from '../../context/Workspaces';

import { Loading } from '../../components/UI';

import { Workspace } from '../../components/Widget';

const Inspiration = () => {
  const { user } = useAuth();

  return (
    <>
      {user?.profile?.inspirationWorkspaceId ? (
        <WorkspacesProvider workspaceId={user.profile.inspirationWorkspaceId}>
          <Workspace
            pageTitle={'Inspiration'}
            workspaceId={user?.profile?.inspirationWorkspaceId}
            category={'INSPIRATION'}
            allowAddWidget={true}
            fixed={false}
          />
        </WorkspacesProvider>
      ) : (
        <Loading status={true} />
      )}
    </>
  );
};

export default Inspiration;
